import { Hubs, OrgHubs } from 'utils/gloo-types';
import HubSectionPreview from 'pages/_AdminAuthoringPages/_components/HubPreview/HubSectionPreview';
import HubHeaderPreview from 'pages/_AdminAuthoringPages/_components/HubPreview/HubHeaderPreview';
import SkeletonWrap, { SkeletonDiscover } from 'components/organisms/SkeletonWrap';
import { HubPreviewView } from '..';

interface HubDisplayProps {
  hub?: Hubs;
  orgHub?: OrgHubs;
  onFavorite: () => void;
  onUnfavorite: () => void;
  previewView?: HubPreviewView;
}

const HubDisplayPreview = ({ hub, orgHub, onFavorite, onUnfavorite, previewView }: HubDisplayProps) => {
  const finalSectionIndex = hub?.sections ? hub.sections.length - 1 : null;
  const sections = hub?.sections
    .map((section, i) => (
      <HubSectionPreview
        hub={hub}
        hubSection={section}
        key={i}
        isFinalSection={i === finalSectionIndex}
        previewView={previewView}
      />
    ))
    .filter((section) => !!section);

  return (
    <SkeletonWrap
      isLoading={!hub}
      skeleton={<SkeletonDiscover />}
      content={
        !!hub && (
          <div className="flex flex-col">
            <HubHeaderPreview
              hub={hub}
              orgHub={orgHub}
              favoriteHub={onFavorite}
              unfavoriteHub={onUnfavorite}
              previewView={previewView}
            />
            {sections}
          </div>
        )
      }
    />
  );
};

export default HubDisplayPreview;
